// Module
var code = "<div ng-controller=\"publicController as publicCtrl\"> <preauth-handler></preauth-handler> </div> ";
// Exports
module.exports = code;